import { render, staticRenderFns } from "./RegisterThankYou.vue?vue&type=template&id=356e719c&"
import script from "./RegisterThankYou.vue?vue&type=script&lang=ts&"
export * from "./RegisterThankYou.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterThankYou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports